import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'ROC' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'ROC', label: 'Rate of Change', pane: 'sub', params: [12, 6], outputs: ['roc', 'maRoc'] })
